import { render, staticRenderFns } from "./SubmitInfoSuccess.vue?vue&type=template&id=f06ba52e&scoped=true&"
import script from "./SubmitInfoSuccess.vue?vue&type=script&lang=js&"
export * from "./SubmitInfoSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SubmitInfoSuccess.vue?vue&type=style&index=0&id=f06ba52e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06ba52e",
  null
  
)

export default component.exports